/**
 * Nass Plan Toggle — Plan A / Plan B switcher for the "no-restart" block
 * (Body Transformation handoff: setNrFull/setNrLite). Pane visibility is
 * class-scoped CSS keyed off the card's data-plan attribute.
 */
document.querySelectorAll('[data-nass-plan-toggle]').forEach((toggle) => {
  const section = toggle.closest('section');
  const card = section?.querySelector('[data-nass-plan-card]');
  if (!card) return;
  const buttons = [...toggle.querySelectorAll('[data-nass-plan-btn]')];

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const plan = btn.dataset.nassPlanBtn;
      card.dataset.plan = plan;
      buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
    });
  });
});
